import React from 'react';

const DeliveryPage = () => {
  return (
    <div className="max-w-screen-xl mx-auto px-4 py-6 md:py-10 w-full">
      <div className="mb-6 md:mb-8">
        <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">Доставка</h1>
      </div>

      <div className="space-y-6 md:space-y-8">
        {/* Таблица доставки */}
        <div className="rounded-lg border border-gray-200 p-4 md:p-6">
          <h2 className="text-lg md:text-xl font-semibold text-gray-900 mt-2 mb-4">Способы доставки</h2>
          {/* Десктопная таблица */}
          <div className="hidden md:block overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-gray-300">
                  <th className="text-left py-3 px-4 font-semibold text-gray-900">Способ доставки</th>
                  <th className="text-left py-3 px-4 font-semibold text-gray-900">Стоимость</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-gray-200">
                  <td className="py-3 px-4 text-gray-700">Самовывоз</td>
                  <td className="py-3 px-4 text-gray-700 font-medium">Бесплатно</td>
                </tr>
                <tr>
                  <td className="py-3 px-4 text-gray-700">Курьерская</td>
                  <td className="py-3 px-4 text-gray-700 font-medium">От 20 тыс. руб.</td>
                </tr>
              </tbody>
            </table>
          </div>
          {/* Мобильные карточки */}
          <div className="md:hidden space-y-3">
            <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
              <div className="font-semibold text-gray-900 mb-1">Самовывоз</div>
              <div className="text-gray-700 font-medium">Бесплатно</div>
            </div>
            <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
              <div className="font-semibold text-gray-900 mb-1">Курьерская</div>
              <div className="text-gray-700 font-medium">От 20 тыс. руб.</div>
            </div>
          </div>
        </div>

        {/* Информация о самовывозе */}
        <div className="rounded-lg border border-gray-200 p-4 md:p-6">
          <div className="space-y-3 md:space-y-4 text-sm md:text-base text-gray-700">
            <p>
              Самовывоз заказа осуществляется с адреса: <strong>г. Санкт-Петербург, ул. Школьная, д. 37</strong>
            </p>
            <p>
              Время доставки с <strong>9:00 до 18:00</strong> по рабочим дням. Служба доставки свяжется с вами по телефону для согласования даты и времени получения заказа. Мы постараемся организовать доставку в удобное для вас время.
            </p>
            <p>
              Для получения оплаченного заказа необходимо предъявить документ, удостоверяющий личность получателя.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeliveryPage;
